import { Outlet } from '@kmi/kmijs';
import { init } from '@ad/uc/lib/m';

import './index.less';

const { href } = window.location;
const env = href.includes('staging.kuaishou.com')
  ? 'staging'
  : href.includes('diag-external-pre.')
  ? 'beta'
  : href.includes('e.kuaishou.com')
  ? 'production'
  : 'test';
console.log('diag env', env);
// 初始化登录组件
init({
  sid: 'kuaishou.ad.infra.diag',
  appKey: 'ad.adUkmConfig.infraDiag',
  env,
});

const initViewPort = (height: number) => {
  const metaEl = document.querySelector('#diagReviewViewportMeta');
  const content = `height=${height},width=device-width,initial-scale=1.0,user-scalable=no`;
  metaEl?.setAttribute('name', 'viewport');
  metaEl?.setAttribute('content', content);
};

if (window.location.pathname.includes('/report/')) {
  const realHeight = window.innerWidth > window.innerHeight ? window.innerWidth : window.innerHeight;
  initViewPort(realHeight);
}

const Layout = () => {
  return (
    <div className="kmi-layout">
      <Outlet />
    </div>
  );
};

export default Layout;
